import { wireDatePicker } from "../../../../shared/date_picker";
import { downloadChartCsv } from "../../shared/csv_download";
function htmlEscape(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

document.addEventListener('alpine:init', () => {
  Alpine.data('PrefixTopListeningMethods', () => ({
    apiUrl: null,
    simplebar: null,

    init() {
      const root = this.$el || document;
      const wrapper = root.closest('[data-top_listening-methods-root]') || root;
      this.apiUrl = (root.closest('[data-top-listening-methods-root]')?.dataset?.apiUrl) || (wrapper?.dataset?.apiUrl) || '/analytics/chart';
      try {
        this.pickerApi = wireDatePicker({
          rootEl: this.$el || document,
          onChange: () => this.fetchAndRender(),
          inputSelector: '#listening-methods-range',
          buttonSelector: '#__none__',
          hiddenFromSelector: '#listening_methods_from',
          hiddenToSelector: '#listening_methods_to',
          maxDate: 'today',
          activeClasses: { add: ['bg-quill-100'], remove: ['bg-white'] }
        });
        const input = (this.$el || document).querySelector('#listening-methods-range');
        const clearBtn = (this.$el || document).querySelector('#listening-methods-clear');
        const fromEl = (this.$el || document).querySelector('#listening_methods_from');
        const toEl = (this.$el || document).querySelector('#listening_methods_to');
        const syncClear = () => {
          try { if (clearBtn) (input && input.value && input.value.trim()) ? clearBtn.classList.remove('hidden') : clearBtn.classList.add('hidden'); } catch (_) {}
        };
        if (input) { input.addEventListener('input', syncClear); input.addEventListener('change', syncClear); setTimeout(syncClear, 0); }
        if (clearBtn) {
          clearBtn.addEventListener('click', () => {
            try { if (input) input.value=''; if (fromEl) fromEl.value=''; if (toEl) toEl.value=''; } catch(_) {}
            syncClear();
            this.fetchAndRender();
          });
        }
      } catch (_) {}
      this.fetchAndRender();
      // CSV download
      const dlBtn = (this.$el || document).querySelector('#prefix-listening-methods-csv');
      if (dlBtn) {
        dlBtn.addEventListener('click', async () => {
          try {
            const params = new URLSearchParams();
            params.append('chart_type', 'audience_top_listening_methods');
            try {
              const from = (this.$el || document).querySelector('#listening_methods_from')?.value;
              const to = (this.$el || document).querySelector('#listening_methods_to')?.value;
              if (from && to) {
                params.append('date_range', 'custom');
                params.append('start_date', from);
                params.append('end_date', to);
              } else {
                params.append('date_range', 'all_time');
              }
            } catch (_) { params.append('date_range', 'all_time'); }
            await downloadChartCsv({
              endpoint: this.apiUrl,
              params,
              filename: 'top_listening_methods.csv',
              columns: ['Listening Method', 'Downloads'],
              dataPath: 'download_data'
            });
          } catch (e) { console.error('listening_methods csv error', e); }
        });
      }
      window.addEventListener('turbo:before-cache', () => this.destroy());
    },

    destroy() {
      try { this.simplebar && this.simplebar.unMount && this.simplebar.unMount(); } catch (_) {}
      this.simplebar = null;
    },

    buildParams() {
      const params = new URLSearchParams();
      params.append('chart_type', 'audience_top_listening_methods');
      try {
        const from = (this.$el || document).querySelector('#listening_methods_from')?.value;
        const to = (this.$el || document).querySelector('#listening_methods_to')?.value;
        if (from && to) {
          params.append('date_range', 'custom');
          params.append('start_date', from);
          params.append('end_date', to);
          return params;
        }
      } catch (_) {}
      params.append('date_range', 'all_time');
      return params;
    },

    async fetchAndRender() {
      try {
        const params = this.buildParams();
        const res = await fetch(`${this.apiUrl}?${params.toString()}`, {
          headers: { 'Accept': 'application/json' },
          cache: 'no-store'
        });
        if (!res.ok) throw new Error(`Fetch failed ${res.status}`);
        const raw = await res.json(); // could be { chart_data: {labels,series}, download_data: [...] }
        const data = (raw && raw.chart_data) ? raw.chart_data : raw;
        this.renderTable(data);
      } catch (e) {
        console.error('PrefixTopListeningMethods fetch error', e);
      }
    },

    groupAndAggregate(labels, series) {
      const temp = {};
      let total = 0;
      const add = (name, val) => {
        temp[name] = (temp[name] || 0) + val;
        total += val;
      };
      const othersList = [
        'bot', 'okhttp', 'asynchronous io library', 'axios', 'ffmpeg', 'wget',
        'java runtime environment', 'airr player', 'curl', 'unknown', 'other'
      ];
      for (let i = 0; i < labels.length; i++) {
        let label = (labels[i] == null || labels[i] === '') ? 'Unknown' : String(labels[i]);
        const val = Number(series[i] || 0);
        const low = label.toLowerCase();
        if (low.includes('apple')) add('Apple Podcasts', val);
        else if (low.includes('amazon') || low === 'alexa media player') add('Amazon Podcasts', val);
        else if (low.includes('google')) add('Google Podcasts', val);
        else if (othersList.includes(low)) add('Other', val);
        else if (low.includes('roku')) add('Roku', val);
        else if (low.includes('tunein')) add('TuneIn', val);
        else add(label, val);
      }
      const sorted = Object.keys(temp).sort((a, b) => temp[b] - temp[a]);
      return { temp, total, sorted };
    },

    renderTable(payload) {
      const labels = Array.isArray(payload?.labels) ? payload.labels.slice() : [];
      const series = Array.isArray(payload?.series) ? payload.series.slice() : [];
      for (let i = labels.length - 1; i >= 0; i--) {
        if (labels[i] == null || labels[i] === '') { labels.splice(i, 1); series.splice(i, 1); }
      }

      const { temp, total, sorted } = this.groupAndAggregate(labels, series);
      const tableBody = this.$el.querySelector('#prefix-listening-table');
      if (!tableBody) return;
      tableBody.innerHTML = '';

      let otherVal = null, otherPct = null, otherGrad = null;
      for (let i = 0; i < sorted.length; i++) {
        const name = sorted[i];
        const value = temp[name];
        const pctRaw = total ? (value * 100.0 / total) : 0;
        let pctDisplay;
        if (pctRaw > 99) pctDisplay = '>99';
        else if (pctRaw < 1 && pctRaw > 0) pctDisplay = '<1';
        else pctDisplay = Math.round(pctRaw);
        const grad = Math.round(pctRaw);
        if (name === 'Other') {
          otherVal = value; otherPct = pctDisplay; otherGrad = grad; continue;
        }
        tableBody.insertAdjacentHTML('beforeend', `
          <tr class="h-20 flex w-full" style="background: linear-gradient(90deg, rgba(56, 21, 153, 0.2) ${grad}%, #FFFFFF 0%)">
            <td class="flex items-center w-7/12 px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">${htmlEscape(name)}</td>
            <td class="flex items-center justify-end w-3/12 px-6 py-4 whitespace-nowrap text-sm text-gray-500">${value}</td>
            <td class="flex items-center justify-end w-2/12 px-6 py-4 whitespace-nowrap text-sm text-gray-500">${pctDisplay}%</td>
          </tr>
        `);
      }
      if (otherVal != null) {
        tableBody.insertAdjacentHTML('beforeend', `
          <tr class="h-20 flex w-full" style="background: linear-gradient(90deg, rgba(56, 21, 153, 0.2) ${otherGrad}%, #FFFFFF 0%)">
            <td class="flex items-center w-7/12 px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Other</td>
            <td class="flex items-center justify-end w-3/12 px-6 py-4 whitespace-nowrap text-sm text-gray-500">${otherVal}</td>
            <td class="flex items-center justify-end w-2/12 px-6 py-4 whitespace-nowrap text-sm text-gray-500">${otherPct}%</td>
          </tr>
        `);
      }

      if (this.simplebar) {
        try { this.simplebar.unMount(); } catch (_) {}
      }
      try { this.simplebar = new SimpleBar(tableBody, { autoHide: false }); } catch (_) {}
    },
  }));
});
